<template
  ><!-- 公告弹框 -->
  <el-dialog
    :visible.sync="dialogNoticeVisible"
    class="notice-dialog"
    width="55%"
    center
    :append-to-body="true"
    :before-close="readNotice"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="notice-content">
      <div class="header">
        <div class="flex-row-start-center">
          <div class="type-name">{{ detail.type_name }}</div>
          <span class="notice-title">{{ detail.title }}</span>
        </div>
      </div>

      <Editor :value="detail.content" @onChange="onChange"></Editor>
      <!-- 阅读类公告按钮 -->
      <el-button
        type="primary"
        class="confirm-btn"
        :loading="confirmLoading"
        @click="readNotice(1)"
        v-if="detail.notice_type === 1"
        >我知道了</el-button
      >
      <!-- 操作类公告按钮 -->
      <div class="flex-row-between-center" v-if="detail.notice_type === 2">
        <el-alert
          title="注意！点击拒绝前请与负责的业务员沟通，知晓相关影响"
          type="warning"
          show-icon
          class="alert-warning"
          :closable="false"
        />
        <div class="flex-row-start-center">
          <el-button
            type="primary"
            class="confirm-btn"
            :loading="confirmLoading"
            @click="readNotice(1)"
            >同意</el-button
          >
          <el-button class="reject-btn" @click="rejectNotice">拒绝</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  getNotice,
  getNoticeDetail,
  confirmNotice
} from "@/models/noticeModel";
import Editor from "./editor";
export default {
  name: "noticeDialog",
  components: { Editor },
  data() {
    return {
      dialogNoticeVisible: false,
      noticeList: [], //未读公告列表
      currentIndex: 0, //当前展示公告下标
      detail: {}, //消息详情
      confirmLoading: false,
      innerVisible: false
    };
  },
  mounted() {
    // 显示公告 --调接口判断
    if (localStorage.getItem("first_login")) {
      this.getUnReadNotice();
    }
  },
  methods: {
    //获取未读公告列表(状态为0的)
    getUnReadNotice() {
      const params = {
        status: 0,
        page: 1,
        page_size: 999
      };
      getNotice(params)
        .then(res => {
          if (res) {
            this.noticeList = res.list;
            if (res.list && res.list.length) {
              // this.getDetail(31);
              this.getDetail(res.list[this.currentIndex].id);
            }
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //获取公告详情
    getDetail(id) {
      //调接口获取公告详情
      getNoticeDetail({ id })
        .then(res => {
          if (res) {
            this.dialogNoticeVisible = true;
            this.detail = res;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 拒绝 - 二次确认弹框
    rejectNotice() {
      this.$confirm(
        "注意！点击拒绝前请与负责的业务员沟通，知晓相关影响！",
        "确认拒绝？",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.dialogNoticeVisible = false;
          this.readNotice(2);
        })
        .catch(() => {});
    },
    //确认公告（设置状态为已读）
    readNotice(status) {
      // 1、调接口，设置为已读，并关闭弹框
      this.confirmLoading = true;
      const params = {
        status: status,
        id: this.noticeList[this.currentIndex].id
      };
      // console.log("params:", params);
      confirmNotice(params)
        .then(res => {
          this.confirmLoading = false;
          const index = this.currentIndex + 1;
          this.currentIndex = index;
          //2、判断当前公告是否为最后一条未读公告，
          // 是->删除查看公告标识
          // 否->请求下一条公告详情
          if (index < this.noticeList.length) {
            const id = this.noticeList[this.currentIndex].id;
            this.getDetail(id);
          } else {
            localStorage.removeItem("first_login");
          }
        })
        .catch(err => {
          this.confirmLoading = false;
          this.$message.error(err.message);
        });
      this.dialogNoticeVisible = false;
    },
    onChange() {}
  }
};
</script>
<style lang="scss">
.notice-dialog {
  .notice-content {
    overflow: hidden;
  }
  .flex {
    margin-top: -10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    font-size: 16px;
    .el-icon-error {
      font-size: 18px;
      color: red;
      margin-right: 10px;
    }
  }

  .el-dialog.el-dialog--center {
    border-radius: 10px;
  }

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    color: inherit;
  }

  .header div {
    font-weight: normal;
  }

  .type-name {
    border: 1px solid #ff4d4f;
    color: #ff4d4f;
    font-size: 12px;
    padding: 0 6px;
    margin-right: 10px;
    background-color: #fff1f0;
    border-radius: 6px;
  }

  .notice-title {
    font-size: 18px;
    font-weight: 500;
  }
  .reject-btn {
    padding: 8px 16px;
    border-radius: 8px;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
  }
  .confirm-btn {
    background-color: #ff6124 !important;
    border-color: #ff6124 !important;
    border-radius: 8px;
    color: #fff !important;
    font-size: 14px;
    font-weight: normal;
    padding: 8px 16px;
    float: right;
    cursor: pointer;
  }

  .el-dialog--center .el-dialog__body {
    padding-bottom: 12px;
  }
}

#shopNoticeContent {
  max-height: 420px;
  overflow-y: scroll;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin: 10px 0;

  .w-e-text-container .placeholder {
    display: none;
  }

  .w-e-toolbar {
    border: none !important;
    display: none !important;
  }

  .w-e-text-container {
    border: none !important;
  }

  .w-e-text-container {
    height: auto !important;
  }
}
.alert-warning {
  width: 500px;
}
.el-message-box {
  width: 500px;
  .el-button:first-child {
    color: #606266;
  }
  .el-button:first-child :hover,
  .el-button:first-child :focus {
    color: #ff6124 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notice/indexNew.vue